webpackJsonp([79611799117203,60335399758886],{

/***/ 116:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(236);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(116);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _logoContainerStyle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Logo = __webpack_require__(44);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	__webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      'nav',
	      { style: navStyle },
	      _react2.default.createElement(
	        'div',
	        { style: logoContainerStyle },
	        _react2.default.createElement(_Logo2.default, null)
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	var navStyle = {
	  top: 10,
	  verticalAlign: 'top',
	  paddingTop: '2.78%',
	  width: '100%',
	  zIndex: 1,
	  textAlign: 'center',
	  fontSize: '22px',
	  // display: 'block',
	  WebkitFontSmoothing: 'antialiased',
	  textRendering: 'optimizeSpeed',
	  cursor: 'pointer'
	};
	
	var logoContainerStyle = (_logoContainerStyle = {
	  verticalAlign: 'middle',
	  textAlign: 'center',
	  whiteSpace: 'nowrap',
	  fontSize: '22px',
	  height: '50px'
	}, _logoContainerStyle['textAlign'] = 'center !important', _logoContainerStyle.border = 0, _logoContainerStyle.margin = 'auto', _logoContainerStyle.padding = 0, _logoContainerStyle.cursor = 'pointer', _logoContainerStyle);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    'a',
	    { href: 'https://altola.co', className: 'logo-link' },
	    _react2.default.createElement(
	      'svg',
	      { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 229.2 27.38', style: { width: '150px' } },
	      _react2.default.createElement(
	        'g',
	        { id: 'Layer_2', 'data-name': 'Layer 2' },
	        _react2.default.createElement(
	          'g',
	          { id: 'Layer_1-2', 'data-name': 'Layer 1' },
	          _react2.default.createElement('polygon', { className: 'logo', points: '11.72 0.64 0 26.79 6.27 26.79 7.42 24.07 8.18 22.3 10.38 17.15 11.66 14.13 14.89 6.54 17.74 13.28 17.94 13.75 21.59 22.3 22.45 24.33 23.48 26.79 29.8 26.79 18.07 0.64 11.72 0.64' }),
	          _react2.default.createElement('polygon', { className: 'logo', points: '217.46 0.64 211.12 0.64 199.4 26.79 205.67 26.79 206.82 24.07 207.58 22.3 209.77 17.15 211.05 14.13 214.29 6.54 217.14 13.28 217.34 13.75 220.98 22.3 221.85 24.33 222.88 26.79 229.19 26.79 217.46 0.64' }),
	          _react2.default.createElement('polygon', { className: 'logo', points: '53.32 0.64 47.49 0.64 47.49 26.78 66.39 26.78 66.39 21.44 53.32 21.44 53.32 0.64' }),
	          _react2.default.createElement('path', { className: 'logo', d: 'M79.34,5.83h8v21h5.79v-21h8V.64H79.34Z' }),
	          _react2.default.createElement('polygon', { className: 'logo', points: '170.94 0.64 165.12 0.64 165.12 26.78 184.01 26.78 184.01 21.44 170.94 21.44 170.94 0.64' }),
	          _react2.default.createElement('path', { className: 'logo', d: 'M131.74,0a13.69,13.69,0,1,0,13.68,13.69A13.69,13.69,0,0,0,131.74,0Zm0,22.15a8.46,8.46,0,1,1,8.46-8.46A8.45,8.45,0,0,1,131.74,22.15Z' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(89);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	__webpack_require__(472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'layout' },
	      _react2.default.createElement(_reactHelmet2.default, null),
	      children()
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-0bb0abd87fc00c7e89e1.js